import Route from "../../../router/Route";
import { RouterView } from "vue-router";

import Index from "../pages/Index.vue";
import BucketValue from "../pages/BucketValue.vue";
import NominalValue from "../pages/NominalValue.vue";

export default new Route(
	"dimensions",
	"/dimension-values",
	RouterView,
	[
		new Route("dimensions.index", "", Index, [], {}),
		new Route(
			"dimensions.nominal",
			"nominal/:name_clean/:id",
			NominalValue,
			[],
			{}
		),
		new Route(
			"dimensions.bucketed",
			"bucketed/:name_clean/:id",
			BucketValue,
			[],
			{}
		),
	],
	{ permissions: ["can_manage_dimension_values"] }
);
